import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberManagementEligibilityHistory defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberManagementEligibilityHistoryService } from 'services/memberManagementEligibilityHistory';
 *
 * // create service instance and send/cancel request
 * const memberManagementEligibilityHistoryService = new MemberManagementEligibilityHistoryService();
 * const result = await memberManagementEligibilityHistoryService.fetchData( '<user-id>' ); // fetch data
 * memberManagementEligibilityHistoryService.cancel(); // cancel an active request
 */
export class MemberManagementEligibilityHistoryService extends HttpService {

      // make request and fetch data
      async fetchComponentData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
            if( SERVICE_RESPONSE_STATUS.SUCCESS === get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ) ) {

                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                    data: {
                        ...get( response, 'body.component.data.state', {} ),
                        ...get( response, 'body.component.structure', {} ),
                    },
                };
            } else {
                return {
                    status: SERVICE_RESPONSE_STATUS.FAILURE,
                    data: get( response, 'body.component.data', {} )
                };
            }
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
